/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function ReviewChangesRequested({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 17" {...props}><path stroke="currentColor" strokeWidth={1.2} d="M7.042 1.57a1.916 1.916 0 0 1 1.916 0l4.565 2.635c.593.342.958.975.958 1.66v5.27c0 .685-.365 1.318-.958 1.66l-4.565 2.636a1.916 1.916 0 0 1-1.916 0l-4.566-2.636a1.916 1.916 0 0 1-.957-1.66v-5.27c0-.685.365-1.318.957-1.66l4.566-2.636Z" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="m5.816 6.351 4.368 4.368M5.815 10.649l4.368-4.368" /></svg>;
}
;